import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/examanet/examanet/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/examanet/examanet/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConcoursSujetsClient"] */ "/home/runner/work/examanet/examanet/src/app/[locale]/concours-9eme-tunisie/sujets-passes/client.tsx");
